import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    QueryDropdown
} from "core/components";
import { ApplicationListLayout, Content } from "core/layouts";
import { observer } from "mobx-react";

const NikoOrderHistoryListTemplate = ({ nikoOrderHistoryListViewStore }) => {
    const { 
        tableStore,
        queryUtility,
        routes,
        authorization,
        facilityOrderPatientStore,
        patientTemplateStore,
        onChangePatient
    } = nikoOrderHistoryListViewStore;

    return (
        <ApplicationListLayout
            store={ nikoOrderHistoryListViewStore }
            authorization={authorization}
        >
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="form__group col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3">
                            <QueryDropdown queryUtility={queryUtility} store={facilityOrderPatientStore} onChange={onChangePatient} onClear={onChangePatient} propertyName="patientId" label="Patient"/>
                        </div>
                        <div className="form__group col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3">
                            <QueryDropdown queryUtility={queryUtility} store={patientTemplateStore} propertyName="patientTemplateId" label="Template"/>
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
}

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_HISTORY.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

NikoOrderHistoryListTemplate.propTypes = {
    nikoOrderHistoryListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(NikoOrderHistoryListTemplate);
